import { useState } from 'react';
import { useParams } from 'react-router-dom';
import useEffectOnce from 'react-use/lib/useEffectOnce';

import {
  AuthFactoryProvider,
  LoadingOverlay,
} from '@spotify/confidence-core-react';

import { AccountCreated } from './AccountCreated';
import { CreateAccountForm } from './CreateAccountForm';
import { InviteError } from './InviteError';
import { CreatedAccount, useInvite } from './hooks/useInvite';

const CLIENT_ID = '82qMvwZvqd3t3S0gRDvs8R53TehQXSJY';

export const SignUpPage = () => {
  const [token, setToken] = useState<string>();
  const [account, setAccount] = useState<CreatedAccount>();
  const { id: inviteId } = useParams();
  const [{ error: inviteError, loading, value: inviteData }, getAccountInvite] =
    useInvite(inviteId);

  useEffectOnce(() => {
    (async () => {
      try {
        if (inviteId) {
          const invite = await getAccountInvite();
          setAccount(invite.createdAccount);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    })();
  });

  const accountDataAvailable = !loading && !!account;

  const renderContent = () => {
    if (loading) {
      return null;
    }
    if (inviteError) {
      return <InviteError error={inviteError} />;
    }
    if (accountDataAvailable) {
      return <AccountCreated createdAccount={account} />;
    }
    return (
      <AuthFactoryProvider
        clientId={CLIENT_ID}
        onTokenReceived={t => setToken(t)}
      >
        <CreateAccountForm
          inviteId={inviteId}
          token={token}
          onCreate={setAccount}
          skipCompanyWizard={inviteData?.warehouseNative ?? false}
        />
      </AuthFactoryProvider>
    );
  };

  return (
    <>
      <LoadingOverlay loading={loading} />
      {renderContent()}
    </>
  );
};
